import BaseComponent from '../base-component/base-component'
import { bodyElement } from '../../components/common/body-element'
import { checkEnterKey } from '../../utils/utils'
import { parseHTML } from '../../utils/dom'
import Pagination from './pagination'

class PaginationLink extends BaseComponent {
  connectedCallback(): void {
    this.addEventListener('keydown', this.handleKeyDown)
    this.addEventListener('click', this.handleLinkClick)
  }

  disconnectedCallback(): void {
    this.removeEventListener('keydown', this.handleKeyDown)
    this.removeEventListener('click', this.handleLinkClick)
  }

  handleLinkClick = (): void => {
    this.fetchResults()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    const isEnterKey = checkEnterKey(event.key || event.keyCode)

    if (isEnterKey) {
      event.preventDefault()

      this.fetchResults()
    }
  }

  fetchResults(): void {
    const pagination = this.closest<Pagination>('pagination-component')
    const url = this.dataset.url

    if (pagination && url) {
      if (pagination.cache[url]) {
        this.updatePaginationFromHTML(pagination.cache[url])
      } else {
        this.getFromUrl(url)
      }
    }
  }

  getFromUrl(url: string): void {
    const pagination = this.closest<Pagination>('pagination-component')

    if (pagination) {
      pagination.loadingOverlay.show()

      fetch(url)
        .then(response => response.text())
        .then(responseText => {
          const html = parseHTML(responseText)

          pagination.loadingOverlay.hide()

          pagination.cache[url] = html

          this.updatePaginationFromHTML(html)
        })
        .catch(() => {
          if (!bodyElement.notification) {
            return
          }

          bodyElement.notification.show(
            'Error in pagination link component',
            'warning',
          )
        })
    }
  }

  updatePaginationFromHTML(html: Document): void {
    const pagination = this.closest<Pagination>('pagination-component')

    if (pagination) {
      pagination.updateResultsFromHTML(html)
      pagination.updateFromHTML(html)
    }
  }
}

export default PaginationLink
